var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmSim1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8989 25.2982V47H35.3106V29.6534H35.1834L30.2136 32.7688V28.6997L35.5861 25.2982H39.8989Z",
    fill: "#264C86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0078 65.9941C16.3578 65.9941 14.9458 65.4071 13.7718 64.2331C12.5978 63.0591 12.0098 61.6461 12.0078 59.9941V23.9941L30.0078 5.99414H54.0078C55.6578 5.99414 57.0708 6.58214 58.2468 7.75814C59.4228 8.93414 60.0098 10.3461 60.0078 11.9941V59.9941C60.0078 61.6441 59.4208 63.0571 58.2468 64.2331C57.0728 65.4091 55.6598 65.9961 54.0078 65.9941H18.0078ZM18.0078 59.9941H54.0078V11.9941H32.5578L18.0078 26.5441V59.9941Z",
    fill: "#264C86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmSim1);
export default __webpack_public_path__ + "static/media/am-sim-1.b5be6e2314b16ad9e7ba9223f9b5dee5.svg";
export { ForwardRef as ReactComponent };